import { createSelector } from '@ngrx/store';
import { featureSelector } from './feature-selector';

export const RoleSelectors = {
  selectAreRolesLoaded: createSelector(featureSelector, (state) => state.rolesState.loaded),
  selectRolesDictionary: createSelector(featureSelector, (state) => state.rolesState.roles.entities),
  selectRoles: createSelector(featureSelector, (state) => Object.values(state.rolesState.roles.entities)),
  selectShouldLoad: createSelector(featureSelector, (state) => !state.rolesState.loaded && !state.rolesState.loading),
  selectByRoleKey: (roleKey: string) => {
    return createSelector(featureSelector, (state) => state.rolesState.roles.entities[roleKey]);
  },
};
